export interface TableColumn {
    id: string;
    name: string;
    type: TableColumn.ColumnType;
    options?: Array<TableColumn.Option>;
}

export namespace TableColumn {
    export interface Option {
        id: number;
        name: string;
    }

    export enum ColumnType {
        date,
        date_range,
        month_year,
        text,
        number,
        option,
        tags,
        boolean,
    }

    export enum SortOrder {
        asc = "asc",
        desc = "desc",
    }
}
